const API_BASE = process.env.REACT_APP_API_URL || '';

export async function login(email, password) {
  const body = new URLSearchParams();
  body.append('username', email);
  body.append('password', password);

  const res = await fetch(`${API_BASE}/token`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({ detail: 'Login fehlgeschlagen' }));
    throw new Error(err.detail || 'Login fehlgeschlagen');
  }

  const data = await res.json();
  return data.access_token;
}

export async function getMe(token) {
  const res = await fetch(`${API_BASE}/api/users/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error('Benutzer konnte nicht geladen werden');
  return res.json();
}
